
/**
 * Prop Type check function for float/integer specific numbers
 * @param {bool} shouldBeInteger
 */
const generateNumberTypePropChecker = shouldBeInteger => {
  const checkType = (isRequired, props, propName, componentName) => {
    const val = props[propName]
    if (isRequired && !val) {
      return new Error(`Prop "${propName}" supplied to "${componentName}" is Required. Value passed: "${val === null ? 'null' : val}".`)
    }
    if (isRequired && (typeof val !== "number" || Number.isInteger(val) !== shouldBeInteger)) {
      return new Error(`Invalid prop "${propName}" supplied to "${componentName}" Expected type: "${shouldBeInteger ? 'integer' : 'float'}". Validation failed. Value passed: "${val}" (type: ${typeof val})`)
    }
  }

  const chainedCheckType = checkType.bind(this, false)
  chainedCheckType.isRequired = checkType.bind(this, true)

  return chainedCheckType
}

export const propTypeFloat = generateNumberTypePropChecker(false)
export const propTypeInt = generateNumberTypePropChecker(true)